import { Fragment, type Node as ProseMirrorNode } from "prosemirror-model";

import { focusSchema } from "../schema";

export const createSourceFragment = (text: string) => {
  const children: ProseMirrorNode[] = [];
  const lines = text.split("\n");

  lines.forEach((line, index) => {
    if (index > 0) {
      children.push(focusSchema.nodes.hard_break.create());
    }

    if (line) {
      children.push(focusSchema.text(line));
    }
  });

  return Fragment.fromArray(children);
};

const escapeMarkdownDestination = (value: string) =>
  value.replace(/\)/g, "%29");

const escapeMarkdownTitle = (value: string) => value.replace(/"/g, '\\"');

export const formatSourceMarkdownImage = ({
  alt = "Image",
  src,
  title,
}: {
  alt?: string | null;
  src: string;
  title?: string | null;
}) => {
  const titleSuffix = title?.trim()
    ? ` "${escapeMarkdownTitle(title.trim())}"`
    : "";

  return `![${alt || ""}](${escapeMarkdownDestination(src)}${titleSuffix})`;
};

export const formatSourceMarkdownLink = ({
  href,
  text,
  title,
}: {
  href: string;
  text: string;
  title?: string;
}) => {
  const label = text || href;
  const titleSuffix = title?.trim()
    ? ` "${escapeMarkdownTitle(title.trim())}"`
    : "";

  return `[${label}](${escapeMarkdownDestination(href)}${titleSuffix})`;
};
